import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { injectCorrelationId } from './correlation.state';

/**
 * Adds a correlation ID to the outgoing request.
 * @param req The outgoing request to be modified.
 * @param next The next handler in the chain.
 * @returns An observable of the HTTP event.
 */
export function correlationInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	const newReq = req.clone({
		setHeaders: {
			'Lvr-Correlation-Id': injectCorrelationId(),
		},
	});
	return next(newReq);
}
